import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import {
  Checkbox,
  FormControlLabel,
  Switch,
  TableHead,
  Tooltip,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { CameraHealthTabAutopatrol } from "./CameraHealthTabAutopatrol";
import { cancelIconRed } from "../../../common/cancelIconRed";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { formatCadenceForDisplay } from "./SiteAboutPageUtils/cameraHealthCadenceUtils";
import { formatReportCadenceForDisplay } from "./SiteAboutPageUtils/cameraHealthReportCadenceUtils";

const capitalizeWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const CameraHealthTab = ({
  healthCheckData,
  siteInfo,
}: {
  healthCheckData: any;
  siteInfo: any;
}) => {
  const titlesArray = [
    "Camera Health Monitoring On",
    "Reports enabled",
    "Report Cadence",
    "Sensitivity",
    "Cadence",
  ];

  const titlesArray2 = [
    "All Metric Notifications",
    "All Metric Emails",
    "Report emails",
    "Cell Numbers",
    "",
  ];

  const { healthCheckMetricsData } = useSiteAboutStore();

  // If integration type is autopatrol, render the autopatrol component
  if (siteInfo.integration_type_name === "autopatrol") {
    return <CameraHealthTabAutopatrol healthCheckData={healthCheckData} />;
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ width: "screen" }}>
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          {healthCheckData.deployment === 0 ? (
            <TableHead>
              <TableRow>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  Camera Health Monitoring On
                </TableCell>
              </TableRow>
              <TableBody>
                <TableRow>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {siteInfo.integration_type_name === "autopatrol" ? (
                      cancelIconRed
                    ) : (
                      <Switch checked={false} disabled={true} color="warning" />
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableHead>
          ) : (
            <>
              <>
                <TableHeadComponent titlesArray={titlesArray} />
                <TableBody>
                  <TableRow>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      <Switch
                        checked={healthCheckData.deployment === 3}
                        disabled={true}
                        color="warning"
                      />
                    </TableCell>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {healthCheckData.report_emails_enabled ? (
                        <Switch
                          defaultChecked
                          disabled={true}
                          color="warning"
                        />
                      ) : (
                        <Switch
                          checked={false}
                          disabled={true}
                          color="warning"
                        />
                      )}
                    </TableCell>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {formatReportCadenceForDisplay(
                        healthCheckData.report_cadence
                      )}
                    </TableCell>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {capitalizeWords(healthCheckData.sensitivity_level)}
                    </TableCell>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {formatCadenceForDisplay(healthCheckData.cadence)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
              <>
                <TableHeadComponent titlesArray={titlesArray2} />
                <TableBody>
                  <TableRow>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {healthCheckData.alert_emails_enabled ? (
                        <Switch
                          defaultChecked
                          disabled={true}
                          color="warning"
                        />
                      ) : (
                        <Switch
                          checked={false}
                          disabled={true}
                          color="warning"
                        />
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      sx={{
                        fontFamily: "Mulish",
                        maxWidth: "300px",
                        overflow: "hidden",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {healthCheckData.alert_emails}
                    </TableCell>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      sx={{
                        fontFamily: "Mulish",
                        maxWidth: "300px",
                        overflow: "hidden",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {healthCheckData.report_emails}
                    </TableCell>
                    <TableCell>{healthCheckData.cell_numbers}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </>
            </>
          )}
        </Table>
        {healthCheckData.deployment !== 0 && (
          <Table
            sx={{
              postion: "absolute",
              width: "screen",
              fontFamily: "Mulish",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{
                    fontFamily: "Mulish",
                    fontWeight: "Bold",
                  }}
                >
                  Health Metrics &nbsp; &nbsp;
                  <Tooltip
                    title="Select metrics in addition to connectivity to monitor. Use fields below to send instant alerts for specific metrics to different recipients."
                    placement="top"
                    sx={{ fontSize: "15px", fontFamily: "mulish" }}
                  >
                    <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                  </Tooltip>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <FormGroup>
                    <div className="flex">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.scene_change_check
                                .enabled &&
                              healthCheckMetricsData.motion_status_check
                                .enabled &&
                              healthCheckMetricsData.recording_check.enabled &&
                              healthCheckMetricsData.stream_quality_check
                                .enabled
                            }
                            disabled={true}
                            name="all_metrics"
                          />
                        }
                        label="All Metrics"
                      />
                      <FormControlLabel
                        sx={{ marginLeft: "20px" }}
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.scene_change_check.enabled
                            }
                            disabled={true}
                            name="scene_change_check"
                          />
                        }
                        label="Scene Change"
                      />
                      <FormControlLabel
                        sx={{ marginLeft: "20px" }}
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.motion_status_check.enabled
                            }
                            disabled={true}
                            name="motion_status_check"
                          />
                        }
                        label="Motion Status"
                      />
                      <FormControlLabel
                        sx={{ marginLeft: "20px" }}
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.recording_check.enabled
                            }
                            disabled={true}
                            name="recording_check"
                          />
                        }
                        label="Recording Status"
                      />
                      <FormControlLabel
                        sx={{ marginLeft: "20px" }}
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.stream_quality_check
                                .enabled
                            }
                            disabled={true}
                            name="stream_quality_check"
                          />
                        }
                        label="Stream Quality"
                      />
                      <FormControlLabel
                        sx={{ marginLeft: "20px" }}
                        control={
                          <Checkbox
                            checked={
                              healthCheckMetricsData.image_quality_check.enabled
                            }
                            disabled={true}
                            name="image_quality_check"
                          />
                        }
                        label="Image Quality"
                      />
                    </div>
                  </FormGroup>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
        {healthCheckData.deployment !== 0 && (
          <Table
            sx={{
              postion: "absolute",
              width: "screen",
              fontFamily: "Mulish",
            }}
          >
            <TableHeadComponent
              titlesArray={[
                "Scene Change Emails",
                "Motion Status Emails",
                "Recording Status Emails",
                "Stream Quality Emails",
              ]}
            />
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.scene_change_check.alert_emails
                    ? healthCheckMetricsData.scene_change_check.alert_emails
                    : ""}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.motion_status_check.alert_emails
                    ? healthCheckMetricsData.motion_status_check.alert_emails
                    : ""}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.recording_check.alert_emails
                    ? healthCheckMetricsData.recording_check.alert_emails
                    : ""}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.stream_quality_check.alert_emails
                    ? healthCheckMetricsData.stream_quality_check.alert_emails
                    : ""}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
        {healthCheckData.deployment !== 0 && (
          <Table
            sx={{
              postion: "absolute",
              width: "screen",
              fontFamily: "Mulish",
            }}
          >
            <TableHeadComponent
              titlesArray={[
                "Image Quality Emails",
                "Connectivity Status Emails",
              ]}
            />
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.image_quality_check.alert_emails
                    ? healthCheckMetricsData.image_quality_check.alert_emails
                    : ""}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: "Mulish",
                    maxWidth: "300px",
                    overflow: "hidden",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {healthCheckMetricsData.connectivity_check.alert_emails
                    ? healthCheckMetricsData.connectivity_check.alert_emails
                    : ""}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </>
  );
};
